import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import {
  deleteMarkListData,
  getMarkListData,
  changeStatus,
} from "../../../../service/MarkingServices";

function ViewMarkingList() {
  const classes = useStyles();
  
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [markingListData, setMarkingListData] = useState([]);
  const navigate = useNavigate();
 const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

   const [page, setPage] = useState(0);
    
          const handlePageChange = (newPage) => {
        setPage(newPage);
        setOnPage(newPage) // Pass newSelection directly
      };
    
  const [rowCount, setRowCount] = useState("");
 const [rows, setRows] = useState([]);

  const fetchMarkListData = async (pageNumber, size, search) => {
     if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;
    try {
      const dataOfMarkingList = await getMarkListData({pageNumber, size, search});
      setMarkingListData(dataOfMarkingList?.markingsystem);
      setRowCount(dataOfMarkingList.count)
    } catch (error) {
      console.error("Error fetching mark list:", error);
    }
  };
  useEffect(() => {
     if (onPage !== undefined && pageSize !== undefined && searchQuery !== undefined) {
    fetchMarkListData(onPage, pageSize , searchQuery);
     }
  }, [onPage, pageSize , searchQuery]);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editcource") {
      navigate(`/admin/editMarkingSystem/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const deleteResponse = await deleteMarkListData(rowId);
      if (deleteResponse?.success) {
        toast.success("Marking deleted successfully");
        await fetchMarkListData(onPage, pageSize , searchQuery);
      } else {
        toast.error("Marking not deleted");
      }
    } catch (error) {
      toast.error("Marking is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = async (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const data = {
      markingsystem: {
        active_status: newStatus,
        id: iddd,
      },
    };
    const response = await changeStatus(data);
    if (response?.success) {
      fetchMarkListData(onPage, pageSize , searchQuery);
      toast.success("Marking status changed successfully");
      handleClose();
    } else {
      toast.error("Cource status is not changed");
    }
  };
  

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div
          className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
          style={{ height: "100%" }}
        >
          {cellValues.value}
        </div>
      ),
    },
    {
      field: "question_count",
      headerName: "Question's Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "total_score",
      headerName: "Total Score",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 130,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "marking_system",
      headerName: "Question Mark System",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editcource", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Search cource name",
      // export: "yes",
    },
  ];

   const style = [
    {
      height:'maxh67',
      style: "viewtable",
          footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode:"server" 
    },
  ];

   useEffect(() => {
    const startIndex = onPage * pageSize;
  
    const mappedRows = markingListData.map((d) => ({
      id: d.id || "N/A",
      name: d.name || "N/A",
      question_count: d.question_count || "N/A",
      total_score: d.total_score || "N/A",
      marking_system: d.marking_system || "N/A",
      active_status: d.active_status || "N/A",
    }));
  
    const finalRows = mappedRows.map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));
  
    setRows(finalRows);
  }, [markingListData, searchQuery, onPage, pageSize]);
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} />
        <TableView columns={columns} rows={rows} Heading={style} />
      </div>
    </>
  );
}
export default ViewMarkingList;
